// extracted by mini-css-extract-plugin
export default {"email":"Contato_email__tr0Co"};